<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "DBA Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current dba profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'DBA Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                 <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in dbaTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileId }}</div>
                </td>
                <td>
                  <div>{{ row.profileName }}</div>
                </td>
                <td>
                  <div>{{ row.dbaType }}</div>
                </td>
                <td>
                  <div>{{ row.dbaFir }}</div>
                </td>
                <td>
                  <div>{{ row.dbaCir }}</div>
                </td>
                <td>
                  <div>{{ row.dbaPir }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'DBA Profile Edit'"
              @close="clkCancel()"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId">{{
                    title.profileId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1) }">
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      autocomplete="off"
                      :disabled="isEditClik"
                      v-model="dbaForm.profileId"
                      :placeholder=" 'INTEGER<0-' + profileMaxNum + '>'"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name">{{
                    title.profileName
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(5)}">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      maxlength="128"
                      autocomplete="off"
                      v-model="dbaForm.profileName"
                      placeholder="STRING<1-128>"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(5) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(5) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="type">{{
                    title.dbaType
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="type"
                      v-model="dbaForm.dbaType"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="fir">{{
                    title.dbaFir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      :disabled="dbaForm.dbaType < '5' && dbaForm.dbaType > '1'"
                      class="form-control"
                      id="fir"
                      v-model="dbaForm.dbaFir"
                      placeholder="INTEGER<256-800000>(kbps)"
                    />
                    <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="cir">{{
                    title.dbaCir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                    <input
                      type="text"
                      :disabled="
                        dbaForm.dbaType < '2' || dbaForm.dbaType == '4'
                      "
                      class="form-control"
                      id="cir"
                      v-model="dbaForm.dbaCir"
                      placeholder="INTEGER<0-800000>(kbps)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="pir">{{
                    title.dbaPir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(4)}">
                    <input
                      type="text"
                      :disabled="dbaForm.dbaType < '3'"
                      class="form-control"
                      id="pir"
                      v-model="dbaForm.dbaPir"
                      placeholder="INTEGER<256-1200000>(kbps)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(4) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(4) }}
                      </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileDba",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      select: [],
      dbaForm: {
        profileId: "",
        profileName: "",
        dbaType: "",
        dbaFir: "",
        dbaCir: "",
        dbaPir: "",
      },

      dbaTable: [],
      profileMaxNum:"2047",
    }
  },

  created() {
    this.loaddbaProfile()
    this.loadProfileNum()
  },

  watch:{
    'dbaForm.dbaType':function(newval, oldval){
        if(oldval != "")
        {
          this.dbaForm.dbaFir = ""
          this.dbaForm.dbaCir = ""
          this.dbaForm.dbaPir = ""
        }
    }
  },

  methods: {
    loaddbaProfile() {
      get("profiledba")
        .then((res) => {
          this.dbaTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadProfileNum() {
      get("profilemaxnum")
        .then((res) => {
          this.profileMaxNum = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        profileId: "",
        profileName: "",
        dbaType: "",
        dbaFir: "",
        dbaCir: "",
        dbaPir: "",
      }

      this.dbaForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.dbaForm.profileId),
        profileName: this.dbaForm.profileName,
        dbaType: Number(this.dbaForm.dbaType),
        dbaFir: Number(this.dbaForm.dbaFir),
        dbaCir: Number(this.dbaForm.dbaCir),
        dbaPir: Number(this.dbaForm.dbaPir),
        operate: 1,
      }

      
      if(this.dbaForm.profileId == "")
      {
        this.showAlertBox(
              "warn",
              "Message",
              "Invalid profileID"
          )
         return 
      }


      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (!this.isEditClik) {
        for (let i = 0; i < this.dbaTable.length; i++) {
          if (this.dbaTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profiledba", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")

            this.loaddbaProfile()
            /*newProfile.dbaFir =
              newProfile.dbaFir % 64 == 0
                ? newProfile.dbaFir
                : Math.ceil(newProfile.dbaFir / 64) * 64
            newProfile.dbaCir =
              newProfile.dbaCir % 64 == 0
                ? newProfile.dbaCir
                : Math.ceil(newProfile.dbaCir / 64) * 64
            newProfile.dbaPir =
              newProfile.dbaPir % 64 == 0
                ? newProfile.dbaPir
                : Math.ceil(newProfile.dbaPir / 64) * 64

            

            /*if (this.isEditClik) {
              let editindex = this.select[0]
              this.dbaTable[editindex] = newProfile
            } else {
              this.dbaTable.push(newProfile)
              this.dbaTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.dbaTable.length; i++) {
        if (this.dbaTable[i].selected) {
          this.dbaForm.profileId = this.dbaTable[i].profileId
          if(this.dbaTable[i].profileName.match(/^INDEX_/) == null)
          {
            this.dbaForm.profileName = this.dbaTable[i].profileName
          }
          this.dbaForm.dbaFir = this.dbaTable[i].dbaFir
          this.dbaForm.dbaPir = this.dbaTable[i].dbaPir
          this.dbaForm.dbaCir = this.dbaTable[i].dbaCir
          this.dbaForm.dbaType = this.dbaTable[i].dbaType
       
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        operate: 2,
      }

      for (i = 0; i < this.dbaTable.length; i++) {
        if (this.dbaTable[i].selected) {
          newProfile.profileId = Number(this.dbaTable[i].profileId)
          del.push(post("profiledba", newProfile))
          id.push(this.dbaTable[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.dbaTable.length; i++) {
                if (this.dbaTable[i].profileId == id[index]) {
                  this.dbaTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.dbaTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.dbaTable[i], "selected", true)
        } else {
          this.$set(this.dbaTable[i], "selected", false)
        }
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.dbaForm.profileId != "")
        {
            let profileid = Number(this.dbaForm.profileId)
            
            if(!isNaN(profileid))
            {
                if(profileid < 0 || profileid > Number(this.profileMaxNum))
                return "profile id must be in range 0-"+ this.profileMaxNum
            }
            else
              return "profile id must be in range 0-"+ this.profileMaxNum
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.dbaForm.dbaFir != "")
        {
            let dbaFir = Number(this.dbaForm.dbaFir)
            if(!isNaN(dbaFir))
            {
                if(dbaFir < 256 || dbaFir > 800000)
                return "fix Bw must be in range 256-800000"
            }
            else
              return "fix Bw must be in range 256-800000"
        }
      }

      if(value == 3 || value == 0)
      {
        if(this.dbaForm.dbaCir != "")
        {
            let dbaCir = Number(this.dbaForm.dbaCir)
            if(!isNaN(dbaCir))
            {
                if(dbaCir < 256 || dbaCir > 800000)
                {
                  if(dbaCir != 0)
                  {
                      return "assured Bw must be 0 or in range 256-800000"
                  }
                }
            }
            else
              return "assured Bw must be 0 or in range 256-800000"
        }
      }
      if(value == 4 || value == 0)
      {
        if(this.dbaForm.dbaPir != "")
        {
            let dbaPir = Number(this.dbaForm.dbaPir)
            if(!isNaN(dbaPir))
            {
                if(dbaPir < 256 || dbaPir > 1200000)
                return "max Bw must be in range 256-1200000"
            }
            else
              return "max Bw must be in range 256-1200000"
        }
      }

      if(value == 5 || value == 0)
      {
        var space=/[\s]/
        if (space.test(this.dbaForm.profileName)) return "Contains illegal characters."
        else
         return nonASCIIchar(this.dbaForm.profileName)
      }
      return null

    },

  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>
